/**
 * list,ul,ol
 * Created by peak on 16/8/18.
 */
import dashboard from "./dashboard.vue";
export default {
    name: "list",
    icon: "custom-icon list",
    show: true,
    i18n: "list",
    dashboard
}


// WEBPACK FOOTER //
// ./src/components/editor/src/modules/list/index.js